import Locations from './Locations';

export default {
  title: 'Locations & Registers',
  description:
    'Define the first locations and add registers where POS terminals are located.',
  path: '/setup/pos-locations',
  rootPath: { name: 'General Setup', uri: '/setup' },
  subPath: [{ name: 'Locations & Registers' }],
  component: Locations,
  buttons: {
    close: {},
    next: {},
  },
};
